import React from 'react';

import { getExternalUrl } from 'utils/url';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

import SystemMessage from './SystemMessage';
import ActionButton from 'components/buttons/action-button/ActionButton';

import type { Campaign, Deliverable } from 'types';

type Props = {
  metadata: {
    payload: {
      deliverable: Deliverable,
      links: Array<{ url: string }>
    }
  },
  subcampaignId: number,
  campaign: Campaign,
  isBrand: boolean
};

class SystemChatMessageLinksUpdated extends SystemMessage<Props> {
  render() {
    const {
      isBrand,
      metadata,
      campaign,
      subcampaignId
    } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon('links-updated-custom-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            {
              (metadata.payload.links || []).length === 0 ?
                `${__t('system_message.links_removed', {
                  brand: campaign.brandProfile.name,
                  deliverableName: metadata.payload.deliverable.name
                })}`
                :
                `${__t('system_message.links_updated', {
                  brand: campaign.brandProfile.name,
                  deliverableName: metadata.payload.deliverable.name
                })}`
            }
            <div className="messages-system-message__links">
              {
                (metadata.payload.links || []).map(link => (
                  <div
                    className="messages-system-message__link"
                    key={`system-chat-message-links-updated-${Math.random()}`}
                  >
                    <a
                      href={getExternalUrl(link.url)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.url}
                    </a>
                  </div>
                ))
              }
            </div>
            <div>
              <ActionButton
                color="tertiary"
                height="minimum"
                link={`/campaigns/${campaign.id}/${isBrand ? 'subcampaigns' : 'details'}/${subcampaignId}#deliverable-${metadata.payload.deliverable.id}`}
              >
                {__t('system_message.view_deliverable')}
              </ActionButton>
            </div>
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageLinksUpdated;
